import { useStartAPetitionPageState } from '#src/app/pages/startAPetitionV2/pageContext';
import { useQueryParamValue } from '#src/app/shared/hooks/location';
import { useTrackView } from '#src/app/shared/hooks/tracking';

import { replaceAllValuesWithTrueRecord } from './utils';

export function useTrackPageView(): void {
	const { data } = useStartAPetitionPageState();
	const loginMethod = data.draft?.metadata?.user?.loginOrJoinMethod;
	const sourceLocation = useQueryParamValue('source_location');

	const draftData = replaceAllValuesWithTrueRecord(data.draft ?? {});

	useTrackView(
		'sap_step_view',
		{
			step: data.normalizedStep,
			login_method: loginMethod,
			draft: draftData,
			source_location: sourceLocation,
		},
		[data.normalizedStep],
	);
}
